import moment from 'moment'
import Holidays from 'date-holidays'
import { getDistrict, getCountry } from '../firestore/location'
import { errorToast } from '../../common/functions'
import { t } from 'i18next'

const dateFormat = 'YYYY-MM-DD'

export const currentDate = async (district) => {
  const distDoc = await getDistrict(district)
  const timeZone = distDoc.timeZone = undefined ? 'America/New_York' : distDoc.timeZone
  const todayDate = moment.tz(new Date(), timeZone).format(dateFormat)
  return todayDate
}

export const last7BusinessDays = async (district) => {
  const districtRec = await getDistrict(district)
  const country = await getCountry(districtRec.country)
  const todayDate = moment(new Date(), dateFormat)
  const holiday = new Holidays()
  holiday.init(country.id)
  let i = 0
  let currentDate = todayDate
  const workingDays = new Array(7)
  try {
    while (i < 7) {
      // const dayOfWeek = currentDate.weekday()
      // #339 : blocked if condition to show adminDashboard Reports on Saturday, Sunday, & Holidays.
      /* if (dayOfWeek !== 0 && dayOfWeek !== 6 && !holiday.isHoliday(new Date(currentDate))) { */
      workingDays[i] = moment(currentDate).format(dateFormat)
      i++
      /* } */
      currentDate = moment(currentDate, dateFormat).subtract(1, 'days')
    }
  } catch (error) {
    errorToast({ message: t('toast.dateParse'), title: t('toast.parseError') })
  }
  return workingDays
}


